// extracted by mini-css-extract-plugin
module.exports = {"holder":"colorcart_holder__-Lhpt","check":"colorcart_check__h89oz","checkmark":"colorcart_checkmark__3DigZ","checked":"colorcart_checked__2jp5n","btn":"colorcart_btn__1Lh1u"};